import "../../../field.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.VisitStep ??= {};

AppointmentBooking.Wizard.Views.VisitStep.VisitTypeField = class VisitTypeField extends (
  AppointmentBooking.Wizard.Views.Field
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.triggerShowVisitTypeHelpAction = this.triggerShowVisitTypeHelpAction.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    this.visitTypeHelpCallout = new AppointmentBooking.Wizard.Views.Callout({
      model: this.model,
      template: "step/visit/fields/visit_type/help_callout",
      className: "borderless with-preceding",
    });

    this.listenTo(this.model, "change:returning_patient change:visit_types", this.render);
    return this.listenTo(this.model, "change:visit_type_id", this.visitTypeHelpCallout.hide);
  }

  // RENDERING

  render() {
    super.render(...arguments);

    this.replaceContents(".visit-type-callout-container", this.visitTypeHelpCallout.render().el);

    return this;
  }

  // EVENT HANDLERS

  handleShowVisitTypeHelpClick() {
    return this.triggerShowVisitTypeHelpAction();
  }

  triggerShowVisitTypeHelpAction() {
    this.$el.find('[data-appointment-booking-wizard-behaviour="show-visit-type-help"]').toggleClass("caret-up");
    return this.visitTypeHelpCallout.toggle();
  }
};
AppointmentBooking.Wizard.Views.VisitStep.VisitTypeField.prototype.template = "step/visit/fields/visit_type";
AppointmentBooking.Wizard.Views.VisitStep.VisitTypeField.prototype.className =
  "appointment-booking-wizard-visit-step-visit-type-field";

AppointmentBooking.Wizard.Views.VisitStep.VisitTypeField.prototype.events = {
  'click [data-appointment-booking-wizard-behaviour="show-visit-type-help"]': "handleShowVisitTypeHelpClick",
};
